import React, { useEffect } from 'react';
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import footer_github from '../../assets/social_icons/footer_github.svg';
import footer_inst from '../../assets/social_icons/footer_inst.svg';
import footer_linkedin from '../../assets/social_icons/footer_linkedin.svg';
import footer_tg from '../../assets/social_icons/footer_tg.svg';
import footer_youtube from '../../assets/social_icons/footer_youtube.svg';
import { MerchantPageByLinkContainer } from '../../components/MerchantPageByLinkContainer';
import { MerchantInfoPanel } from '../../components/MerchantInfoPanel';
import { PaymentInfoPanel } from '../../components/PaymentInfoPanel';
import { LanguageSelect } from '../../components/LanguageSelect';
import { useAppSelector } from '../../hooks/redux';
import { IMerchant } from '../../models/IMerchant';
import styles from './index.module.css';

export function MerchantPageByLink () {
	const { id } = useParams();
	const { i18n } = useTranslation('translation');
	const { language } = useAppSelector(state => state.languageSlice);

	function isCountryUz () {
		return window.location.toString().includes('uz');
	}

	const merchant: IMerchant = useAppSelector(state => {
		return find(state.merchantReducer.merchants, m => m.id.toString() === id) || null;
	});

	useEffect(() => {
		i18n.changeLanguage(language);
	}, [language]);

	return (
		<div className={styles.container}>
			<MerchantPageByLinkContainer>
				<header className={styles.header}>
					<svg xmlns="http://www.w3.org/2000/svg" width="120" height="40" viewBox="0 0 120 40" fill="none">
						<path
							d="M39.9246 19.5033V7.16943H47.484V8.07634C47.484 8.98324 46.7144 9.75411 45.8091 9.75411H42.9574V12.3388H46.7144V13.2003C46.7144 14.1526 45.9449 14.9235 44.9943 14.9235H42.9574V19.5033H39.9246Z"
							fill="black"></path>
						<path
							d="M52.1458 12.7469H53.4585C53.9564 12.7469 54.3185 12.6109 54.5901 12.3388C54.8617 12.0667 54.9975 11.704 54.9975 11.2052C54.9975 10.525 54.7712 10.0715 54.2732 9.89015C54.0017 9.75411 53.6395 9.70877 53.1416 9.70877H52.1458V12.7469V12.7469ZM49.1582 19.5033V7.16943H53.4585C54.5448 7.16943 55.3596 7.26012 55.8576 7.44151C56.5818 7.71358 57.125 8.16703 57.5324 8.75652C57.9398 9.39135 58.1208 10.1169 58.1208 11.0238C58.1208 11.704 57.9398 12.3841 57.6229 13.019C57.3061 13.6538 56.8534 14.1073 56.2649 14.4247V14.47C56.4007 14.606 56.5365 14.8781 56.7176 15.1955L59.1167 19.5033H55.767L53.5943 15.3316H52.191V19.5033H49.1582Z"
							fill="black"></path>
						<path
							d="M60.4751 19.5033V7.16943H68.1703V9.75411H63.5079V11.976H67.2197V14.5607H63.5079V16.9187H68.4419V19.5033H60.4751Z"
							fill="black"></path>
						<path
							d="M70.3428 19.5033V7.16943H78.0832V9.75411H73.3756V11.976H77.1327V14.5607H73.3756V16.9187H78.3096V19.5033H70.3428Z"
							fill="black"></path>
						<path
							d="M83.2438 16.9187H84.466C85.5071 16.9187 86.3671 16.6012 86.9556 15.9664C87.544 15.3316 87.8609 14.47 87.8609 13.291C87.8609 12.1574 87.544 11.2505 86.9556 10.661C86.3671 10.0715 85.5523 9.75411 84.5112 9.75411H83.289V16.9187H83.2438ZM80.2562 19.5033V7.16943H84.647C86.5934 7.16943 88.1325 7.71358 89.2641 8.80186C90.3958 9.89015 90.9842 11.3865 90.9842 13.291C90.9842 15.2409 90.3958 16.7373 89.2641 17.8256C88.1325 18.9138 86.5934 19.458 84.647 19.458H80.2562V19.5033Z"
							fill="black"></path>
						<path
							d="M95.3755 13.2456C95.3755 14.2886 95.6924 15.1955 96.3261 15.8757C96.9598 16.5558 97.7294 16.9186 98.7252 16.9186C99.6758 16.9186 100.491 16.5558 101.124 15.8757C101.758 15.1955 102.075 14.2886 102.075 13.2456C102.075 12.248 101.758 11.3865 101.124 10.7063C100.491 10.0261 99.7211 9.70872 98.7252 9.70872C97.7746 9.70872 96.9598 10.0261 96.3261 10.7063C95.6924 11.3865 95.3755 12.248 95.3755 13.2456ZM92.2522 13.2456C92.2522 11.4318 92.8407 9.93544 94.0628 8.75647C95.285 7.57749 96.824 6.94266 98.6799 6.94266C100.581 6.94266 102.12 7.53215 103.297 8.75647C104.519 9.98079 105.108 11.4772 105.108 13.2456C105.108 15.1048 104.519 16.6012 103.297 17.8709C102.075 19.0952 100.536 19.73 98.6799 19.73C96.7788 19.73 95.2397 19.0952 94.0628 17.8709C92.8407 16.6465 92.2522 15.1048 92.2522 13.2456Z"
							fill="black"></path>
						<path
							d="M106.556 19.5033L107.552 7.16943H110.811L112.622 12.3841L113.255 14.4247H113.301C113.527 13.6085 113.753 12.9283 113.934 12.3841L115.745 7.16943H119.004L120 19.5033H116.967L116.605 13.9712C116.56 13.6991 116.56 13.3817 116.56 13.019C116.56 12.6562 116.56 12.3841 116.56 12.2028V11.8853H116.515C116.243 12.7469 116.017 13.4271 115.836 13.9712L114.523 17.5535H111.943L110.63 13.9712L109.951 11.8853H109.906C109.951 12.6562 109.951 13.3364 109.906 13.9712L109.544 19.5033H106.556V19.5033Z"
							fill="black"></path>
						<path
							d="M15.6167 38.1401C15.6167 38.1401 0 33.5149 0 10.7516V2H31.2334V10.7063C31.2334 32.6987 15.6167 38.1401 15.6167 38.1401Z"
							fill="#4DBD41"></path>
						<path
							d="M24.6243 10.7971H12.0404V18.0523H24.6243V20.2289C24.6243 23.9019 23.5832 26.8493 18.0155 26.8493H12.0404V36.4171C14.1226 37.6868 15.6164 38.1403 15.6164 38.1403C15.6164 38.1403 31.2331 32.6988 31.2331 10.7064V4.13135C31.2331 7.80431 29.6035 10.7064 24.6243 10.7971Z"
							fill="#1C5030"></path>
						<path
							d="M39.9696 31.9281V23.2672H43.5456C44.3604 23.2672 45.0394 23.5392 45.5826 24.0834C46.0805 24.6275 46.3521 25.353 46.3521 26.2146C46.3521 27.0761 46.0805 27.8017 45.5826 28.3912C45.0846 28.9353 44.4057 29.2527 43.5456 29.2527H42.0971V31.9281H39.9696ZM42.0971 27.4389H43.1382C43.5003 27.4389 43.7719 27.3482 43.953 27.1215C44.1341 26.8948 44.2246 26.6227 44.2246 26.2599C44.2246 25.8972 44.1341 25.6251 43.953 25.3984C43.7719 25.1716 43.5003 25.081 43.1835 25.081H42.0971V27.4389Z"
							fill="#0E0E0E"></path>
						<path
							d="M46.6235 31.9281L49.5658 23.2672H51.7838L54.7261 31.9281H52.5534L52.0102 30.1143H49.3395L48.8416 31.9281H46.6235ZM49.8374 28.3912H51.5575L51.0596 26.7134L50.6975 25.217H50.6522C50.5164 25.8518 50.4259 26.3506 50.2901 26.7134L49.8374 28.3912Z"
							fill="#0E0E0E"></path>
						<path
							d="M57.4423 31.9281V28.3912L54.5906 23.2672H56.9897L57.9855 25.353L58.4834 26.5774H58.5287C58.7098 26.1239 58.8456 25.7158 59.0266 25.353L59.9772 23.2672H62.3763L59.5245 28.3912V31.9281H57.4423Z"
							fill="#0E0E0E"></path>
					</svg>

					<LanguageSelect value={language}/>
				</header>

				{!isNil(merchant)
					? (
						<div className={styles.content}>
							<PaymentInfoPanel merchant={merchant}/>
							<MerchantInfoPanel merchant={merchant}/>
						</div>
					) : (
						<span>Merchant not found</span>
					)
				}

			</MerchantPageByLinkContainer>

			<footer className={styles.footer__wrapper}>
				<MerchantPageByLinkContainer>
					<div className={styles.footer}>
						<div className={styles.footer__upper}>
							<img src="/assets/images/fpay-logo-white.svg" alt="freedompay"/>

							<div>
								<a href="https://www.youtube.com/channel/UC6iIDeXYOobd96HVDuGwYaw" target="blank" className={styles.social_link}>
									<img src={footer_youtube} alt="youtube_icon"/>
								</a>
								<a href="https://github.com/paybox" target="blank" className={styles.social_link}>
									<img src={footer_github} alt="github_icon"/>
								</a>
								<a href="https://kz.linkedin.com/company/freedompay-money" target="blank" className={styles.social_link}>
									<img src={footer_linkedin} alt="linkedin_icon"/>
								</a>
								<a href="https://t.me/freedompay" target="blank" className={styles.social_link}>
									<img src={footer_tg} alt="telegram_icon"/>
								</a>
								<a href="https://instagram.com/fpay.money?igshid=NDBlY2NjN2I=" target="blank" className={styles.social_link}>
									<img src={footer_inst} alt="instagram_icon"/>
								</a>
							</div>
						</div>

						<div className={styles.footer__divider}></div>

						<div className={styles.footer__lower}>
							<div className={styles.footer__links_and_copyright}>
								{isCountryUz() ? (
									<div className={styles.footer__lower_links}>
										<a href="https://freedompay.money/uz/rules" target="blank">Правила осуществления деятельности</a>
										<a href="https://freedompay.money/uz/document/terms" target="blank">Договор на оказание услуг</a>
									</div>
								) : (
									<div className={styles.footer__lower_links}>
										<a href="https://freedompay.money/kz/sfm" target="blank">Памятка СФМ</a>
										<a href="https://freedompay.money/kz/terms" target="blank">Договор присоединения</a>
										<a href="https://freedompay.money/kz/public_offer" target="blank">Публичная оферта</a>
										<a href="https://freedompay.money/kz/privacy_policy" target="blank">Политика конфиденциальности</a>
									</div>
								)}

								<div className={styles.footer__copytight}>© 2024 Freedom Pay</div>
							</div>

							<div className={styles.footer__span}>
								Организация соответствует требованиям стандарта PCI DSS
							</div>

							{isCountryUz() ? (
								<div className={styles.footer__span}>
									Лицензия платежной организации №5 от 23.04.2020 ЦБ РУ
								</div>
							) : (
								<div className={styles.footer__span}>
									Регистрационный номер платежной организации № 02-23-153
								</div>
							)}
						</div>
					</div>
				</MerchantPageByLinkContainer>
			</footer>
		</div>
	);
}
